import { fetchArticle } from '@elevio/kb-kit/lib/api/article';
import { Categories } from '@elevio/kb-kit/lib/components';
import { useCategories, useLanguages } from '@elevio/kb-kit/lib/hooks';
import { useEffect, useState } from 'react';
import ArticleList from '../components/ArticleList';
import Footer from '../components/Footer';
import Header from '../components/Header';
import HomeArticles from '../components/HomeArticles';
import { MainSection } from '../components/layouts/Main';
import PageLayout from '../components/layouts/Page';
import Breadcrumb from '../components/PageBreadcrumbs';
import { homeArticleIds } from '../utils/constants';
export const getHeader = () => {
    return (<Header breadcrumbs={<div className="breadcrumbs-header-wrapper">
          <Breadcrumb className="breadcrumbs-header"/>
        </div>}>
      <div className="header-container"/>
    </Header>);
};
const HomePage = () => {
    useCategories();
    const { selectedLanguage } = useLanguages();
    const [articles, setArticles] = useState([]);
    useEffect(() => {
        const fetchArticles = async () => {
            const response = await Promise.all(homeArticleIds.map((id) => fetchArticle(id, selectedLanguage.id)));
            setArticles(response);
        };
        fetchArticles();
    }, [selectedLanguage.id]);
    return (<PageLayout header={getHeader()} footer={<Footer />}>
      <MainSection className="page-text-color">
        <h1 className="visually-hidden">Ask Boulder County Home</h1>
        <section className="button-container" aria-label="Quick actions">
          <div className="button-wrapper">
            <a href="https://agency.comcate.com/private-submission/create?crm_token=i7ibzzqwvj&logout_redirect_url=https%3A%2F%2Fbouldercountyco.comcate.com%2Fen" className="cta" target="_blank" rel="noopener noreferrer">
              Submit a Request
            </a>
          </div>
          <div className="button-wrapper">
            <a href="https://agency.comcate.com/private-submission/listing?crm_token=i7ibzzqwvj&auth_enabled=true&logout_redirect_url=https%3A%2F%2Fbouldercountyco.comcate.com%2Fen" className="cta-request" target="_blank" rel="noopener noreferrer">
              Login to Account
            </a>
          </div>
        </section>
        <section className="article-container" aria-label="Featured articles">
          <h2 className="visually-hidden">Featured Articles</h2>
          <div className="view-requests-section">
            <HomeArticles articles={articles}/>
          </div>
          <div className="view-requests-section">
            <Categories.Loop limit={1}>
              <ArticleList />
            </Categories.Loop>
          </div>
        </section>
      </MainSection>
    </PageLayout>);
};
export default HomePage;
